<template>
  <el-dialog
    title="监测规则"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose"
  >
    <div>
      <div class="box-table">
          <table style="width: 100%">
        <tbody>
          <tr>
            <th class="th title-th"><strong>一级指标</strong></th>
            <th class="title-th" style="flex: 1"><strong>评分细则</strong></th>
          </tr>
          <tr>
            <th class="th">登录得分</th>
            <th style="flex: 1">
              1. 管理员账号每日首次登录计一次登录天数；<br>
              2. 同组织内，每天若有一个账号登录，则记录组织得0.3分，多人登录不重复得分；<br>
              3. 若一个账号同时处于多个组织，则仅按其主要组织进行记录；
            </th>
          </tr>
          <tr>
            <th class="th">发稿得分</th>
            <th style="flex: 1">
              1. 管理员账号创作的稿件通过审核并发布时，该账号记录一篇发稿量；<br>
              2. 同组织内，发布一篇稿件，则记录组织得1分，发布多篇稿件可重复得分；<br>
              3. 若一个账号同时处于多个组织，则仅按其主要组织进行记录；<br>
              4. 发布稿件得分不设上限；
            </th>
          </tr>
          <tr>
            <th class="th">报送得分</th>
            <th style="flex: 1">
              1. 管理员账号通过信息报送模块报送稿件被采纳并评分后，该稿件创作人员所在组织记录得分；<br>
              2. 报送稿件得分不设上限；
            </th>
          </tr>
        </tbody>
      </table>
      </div>
      <div @click="handleClose" class="btn">我知道了</div>
    </div>
  </el-dialog>
</template>
<script >
export default {
  data() {
    return {};
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
.th {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
   padding-left: 16px;
    padding-right: 16px;
}
.dis-box {
  display: flex;
}
tr{
  display: flex;
}
th{
   border:solid 1px #E4E7ED;
   background-color: rgba(255, 255, 255, 1);
    color:rgba(102, 111, 128, 1);
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    font-weight: normal !important;
}
.title-th{
  height: 36px;
  line-height: 20px;
  background-color: rgba(245, 247, 250, 1);
  font-size: 13px;
  text-align: center;
  color: #000 !important;
  font-weight: 600;
}
.th-two{
  width: 120px;
  text-align: center;
}
.th-three{
  width: 46px;
  text-align: center;
}
.txt-box{
  margin-bottom: 5px;
}
.end-box{
  display: flex;
  width: 100%;
}
/deep/ .el-dialog__body{
   padding: 0px 20px;
   padding-top: 10px;
}
.btn{
  width: 96px;
  height: 36px;
  line-height: 20px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  text-align: center;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 24px;
  margin-left: auto;
  cursor: pointer;
}
/deep/ .el-dialog{
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}

</style>
